module.exports = __webpack_public_path__ + "img/create-game-icon.7d7f5c82.svg";